import { getGroupPermissionFactory, PermissionEnum } from '../../../../common';
import { StatesPermissions } from './states.permissions';

export class StateCitiesPermissions {
    static GroupName = `${StatesPermissions.GroupName}.Cities`;

    static getPermissions = getGroupPermissionFactory(StateCitiesPermissions.GroupName);

    static Permissions = {
        ReadAll: StateCitiesPermissions.getPermissions(PermissionEnum.READ_ALL),
    };
}
